


















































import { Component, Vue } from 'vue-property-decorator';
import CartTotals from '@/components/Cart/Totals.vue';
import { CartItem as CartItemModel, HandledError, Totals } from '@/store/models';
import CartSummaryDetails from '@/components/Checkout/CartSummaryDetails.vue';
import GlamCardUse from '@/components/Cart/GlamCardUse.vue';
import GiftCard from '@/components/Cart/GiftCard.vue';
import Modal from '@/components/UI/Modal.vue';
import Coupon from '@/components/Cart/Coupon.vue';
import Agreement from '@/components/Cms/Agreement.vue';
import checkout from '@/store/modules/checkout';
import cart from '@/store/modules/cart';
import user from '@/store/modules/user';
import cms from '@/store/modules/cms';
import payment from '@/store/modules/payment';
import ui from '@/store/modules/ui';
import store from '@/store';
import CmsBlock from '@/components/Cms/Block.vue';
import gtmhelpers from '@/commons/gtmhelpers';

@Component({
  components: {
    CartTotals,
    GlamCardUse,
    GiftCard,
    Coupon,
    Agreement,
    Modal,
    CartSummaryDetails,
    CmsBlock,
  },
})
export default class CartSummary extends Vue {
  private modalId = 'bagDetails';

  get loading(): boolean {
    return checkout.placingOrder;
  }

  get items(): CartItemModel[] { // get method si traduce in una computed
    return cart.cart.items;
  }

  get totals(): Totals {
    return cart.totals;
  }

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get isFidelityUser(): boolean {
    return user.isFidelity;
  }

  get giftCardEnabled(): boolean {
    return store.state.options.payment.giftcard_enabled;
  }

  get isFidelityEnabled(): boolean {
    return store.state.options.fidelity.enabled;
  }

  get isKlarnaPaymentSelected(): boolean {
    return checkout.selectedPayment === 'klarna_pay_later';
  }

  get canPlace(): boolean {
    return checkout.canPlaceOrder;
  }

  get canUseDiscounts(): boolean {
    return !cart.isGiftcardCart;
  }

  get placeErrors(): any {
    return checkout.placeErrors;
  }

  private toggleModal(direction: boolean) {
    direction ? ui.openModal(this.modalId) : ui.closeModal(this.modalId) ;
  }

  private agreementExist(name: string): boolean {
    return cms.hasAgreements && cms.agreementByName(name) !== undefined;
  }

  private async place() {
    
    checkout.validateBeforePlace();
    if (Object.keys(this.placeErrors).length > 0) {
      return;
    }

    gtmhelpers.trackPlaceOrder();
    const paymentMethod = checkout.selectedPaymentMethod.code;

    const valid = await this.$validator.validateAll();
    if (!valid) {
      return;
    }

    try {
      await payment.validate(paymentMethod);
    } catch (errorMessage) {
      this.$toast.err(errorMessage);
      return;
    }

    checkout.flagPlacingOrder(true);

    const billingAddress = checkout.paymentBillingAddress;
    if (!billingAddress.extension_attributes) {
      billingAddress.extension_attributes = {};
    }
    billingAddress.extension_attributes.approved_agreements = cms.approvedAgreementIds;
    if (billingAddress.hasOwnProperty('id')) {
      delete billingAddress.id;
    }

    const isValid = await checkout.validateBeforePay();
    if (!isValid) {
      cart.flagLoading({key: 'processingpayment', value: false});
      checkout.flagPlacingOrder(false);
      return;
    }

    const totals = await payment.payReady();
    const payResult = await payment.pay({paymentMethod, totals});
    if (payResult.error) {
      checkout.flagPlacingOrder(false);
      cart.flagLoading({key: 'processingpayment', value: false});
      this.$toast.err(payResult.error);
    } else if (payResult.needsFinalization) {

      /* gtm tracking options */
      const checkoutOptionMode = this.isLogged ? 'login' : 'guest';
      const checkoutOptionShipping = checkout.selectedShippingMethod.method_code;
      const gtmOptionString = checkoutOptionShipping + ' - ' + checkoutOptionMode + ' - ' + paymentMethod;

      cart.flagLoading({key: 'processingpayment', value: true});
      await payment.finalize(payResult.finalizeData || { payData: {} });
    }
  }
}
